import React, { FC } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';

interface Props extends SectionProps {}

export const Calendar: FC<Props> = ({ onClickItem, isMobile }) => {
  const { t } = useI18n();
  return (
    <Can hasRoles={['buildingManager', 'admin', 'commercial', 'agent', 'staff']}>
      <NavigationLink
        to={Private.CALENDAR.route}
        icon="calendar"
        title={t('asideNavigation.calendar')}
        onClick={onClickItem}
        isMobile={isMobile}
      />
    </Can>
  );
};
